import { HawkSearchComponents, PopularQueriesContent, PopularQueriesContentComponentConfig, PopularQueriesContentComponentModel } from '@models';
import { searchService } from '@services';
import { BaseContentComponent } from '../base-content.component';
import defaultHtml from './popular-queries-content.component.hbs';

export class PopularQueriesContentComponent extends BaseContentComponent<
    PopularQueriesContentComponentConfig,
    PopularQueriesContent,
    PopularQueriesContentComponentModel
> {
    protected override componentName: keyof HawkSearchComponents = 'popular-queries-content';
    protected override defaultHtml = defaultHtml;

    protected override renderContent(): boolean {
        return !!this.data?.items?.length;
    }

    protected override getContentModel(): PopularQueriesContentComponentModel {
        return {
            ...this.data!
        };
    }

    protected bindChildElements(): void {
        this.rootElement.querySelectorAll('[hawksearch-query]').forEach((e) => {
            e.addEventListener('click', (event: Event) => {
                event.preventDefault();

                const element = event.currentTarget as HTMLElement;
                const query = element.getAttribute('hawksearch-query');

                if (query) {
                    searchService.query(query);
                }
            });
        });
    }
}
